import { Crisp } from 'crisp-sdk-web'
import { useEffect } from 'react'

interface CrispChatWidgetProps {
  websiteID: string
  avatarURL?: string
  colorTheme?: string
}

function overrideAvatar(avatarURL: string) {
  const els = document.querySelectorAll(
    '.crisp-client [style*="image.crisp.chat/avatar"], .crisp-client [style*="melvin"]',
  )
  for (const el of els) {
    ;(el as HTMLElement).style.setProperty('background-image', `url('${avatarURL}')`, 'important')
    ;(el as HTMLElement).style.setProperty('background-size', 'cover', 'important')
  }
}

export function CrispChatWidget({ websiteID, avatarURL, colorTheme }: CrispChatWidgetProps) {
  useEffect(() => {
    if (!websiteID) return
    Crisp.configure(websiteID)
    if (colorTheme) {
      Crisp.setColorTheme(colorTheme as Parameters<typeof Crisp.setColorTheme>[0])
    }
  }, [websiteID, colorTheme])

  useEffect(() => {
    if (!avatarURL) return

    const observer = new MutationObserver(() => overrideAvatar(avatarURL))
    observer.observe(document.body, { childList: true, subtree: true, attributes: true })

    const interval = setInterval(() => overrideAvatar(avatarURL), 500)
    const timeout = setTimeout(() => clearInterval(interval), 10000)

    return () => {
      observer.disconnect()
      clearInterval(interval)
      clearTimeout(timeout)
    }
  }, [avatarURL])

  return null
}
